import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MemberDetails } from './models/member-details.model';
import { Observable } from 'rxjs';
import { MemberState, MemberStore } from './member.store';
import { UserContext } from './models/user-context.model';
import { LoggingService } from '../../shared/services/core/logging.service';
import { LoginType } from '../models/login-response.model';
import { ClientType } from './models/client-type.model';

@Injectable({ providedIn: 'root' })
export class MemberQuery extends QueryEntity<MemberState, MemberDetails> {
  userContext$ = this.select((state) => state.user);
  constructor(protected store: MemberStore, private loggingService: LoggingService) {
    super(store);
  }

  /** Gets the current user's member details. */
  selectMemberDetails(): Observable<MemberDetails | undefined> {
    return this.selectFirst();
  }

  /** Get the user context of the currently logged in user. */
  getUserContext(): UserContext {
    const context = this.getValue().user as UserContext;
    if (context) {
      return context;
    } else {
      this.loggingService.error('user context referenced before login');
      throw new Error('user context referenced before login');
    }
  }

  getPortalId() {
    return this.getValue().user?.portalId;
  }

  /** Get the loginType of the currently logged in user. */
  getLoginType(): LoginType {
    return this.getUserContext().loginType;
  }

  /** Get the clientType of the currently logged in user. */
  getClientType(): ClientType {
    return this.getUserContext().clientType;
  }

  /** Get the population ID of the currently logged in user. */
  getPopulationId(): number {
    return +this.getUserContext().populationId;
  }

    /** Get the population name of the currently logged in user. */
    getPopulationName(): string | undefined {
      return this.getUserContext().populationName;
    }

  /** Get the list of available accounts from translation that the user can log into. */
  getAvailableAccounts(): MemberDetails[] | undefined {
    return this.getValue().availableAccounts as MemberDetails[];
  }

  /** Get the club ID of the currently logged in user. */
  getClubId(): number {
    return this.getUserContext().clubId;
  }
}
